import React from 'react'
import { isEmpty } from 'lodash'
import CurrencyFormat from 'react-currency-format'
import { getUrlOfDefaultProductImage } from '../../../helpers/utils'

const ProductCard = ({
  keyItem,
  item,
  gallery,
  itemAction,
}) => {
  return (
    <div className="col-6 col-md-3 col-lg-3 cursor-pointer" onClick={() => itemAction(item)} key={ "product" + keyItem } style={{ paddingLeft: 6, paddingRight: 6 }}>
      <div className="m-product m-product-5 text-center">
        <figure className="m-product-media">
          <div>
            <img alt="product" src={!isEmpty(gallery) ? gallery[0] : getUrlOfDefaultProductImage()}/>
            { gallery[1] ?
              <span className="m-product-image-hover m-product-image">
                <img
                  alt="product"
                  src={!isEmpty(gallery) ? gallery[1] : getUrlOfDefaultProductImage()}
                />
              </span>
              : ''
            }
          </div>
        </figure>
        <div className="m-product-body">
          <h5 className="m-product-title">
            <div>{ item.product ? item.product.name : item.name }</div>
          </h5>
          <div className="m-product-price">
            <CurrencyFormat
              value={item.product ? Math.round(item.product.wholeSalePrice) : Math.round(item.wholeSalePrice)}
              displayType="text"
              decimalScale={2}
              thousandSeparator
              prefix="$"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

ProductCard.defaultProps = {
  profit: 0,
}

export default ProductCard
